<template>
  <div class="field">
    <label v-if="label" class="block mb-2"><strong>{{ label }}</strong> <span v-if="required" class="p-invalid">*</span></label>
    <div class="p-inputgroup">
      <Dropdown
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :options="trabajadores"
        optionLabel="nombre_completo"
        dataKey="id"
        :filter="true"
        :placeholder="placeholder"
        :loading="cargando"
        :class="{ 'p-invalid': error }"
        :showClear="showClear"
      >
        <template #option="slotProps">
          <div class="p-dropdown-car-option">
            <span>{{ slotProps.option.nombre_completo }}</span>
          </div>
        </template>
      </Dropdown>
    </div>
    <small class="p-error" v-if="error">
      <i class="pi pi-exclamation-circle"></i> 
      {{ error }}
    </small>
  </div>
</template>

<script>
import TrabajadorService from "@/service/TrabajadorService";

export default {
  name: 'SelectTrabajador',
  props: {
    label: { type: String, default: 'TRABAJADOR' },
    modelValue: { type: [Object, String, Number], default: null },
    placeholder: { type: String, default: 'Seleccione un trabajador' },
    required: { type: Boolean, default: false },
    error: { type: String, default: null },
    showClear: { type: Boolean, default: true },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      trabajadores: [],
      cargando: false,
      trabajadorService: null,
    }
  },
  created() {
    this.trabajadorService = new TrabajadorService();
  },
  mounted() {
    this.cargarTrabajadores();
  },
  methods: {
    cargarTrabajadores() {
      this.cargando = true;
      this.trabajadorService.getTrabajadoresActivos().then(response => {
        const rawTrabajadores = response.trabajadores ? response.trabajadores : (response.data ? response.data : response);
        this.trabajadores = Array.isArray(rawTrabajadores) ? rawTrabajadores : [];
      }).catch(err => {
        console.error("Error al cargar trabajadores:", err);
      }).finally(() => {
        this.cargando = false;
      });
    },
    // Este método se puede llamar desde el padre usando $refs para forzar recarga
    recargar() {
      this.cargarTrabajadores();
    }
  }
}
</script>

<style scoped>
.p-error {
  color: #f44336;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.25rem;
}
.p-invalid {
  color: red;
}
</style>
